import * as React from 'react';
import * as style from './advanceRocket.module.scss';

export const AdvanceRocket = ({ className, bgColor }) => {
  return (
    <section className={className || 'rocket'} style={{ backgroundColor: bgColor }}>
      <div className={`${style.rocket__wrapper} container`}>
        <div className={`${style.rocket__row} row`}>
          <div className={`${style.rocket__colFirst} col-12 col-lg-3`}>
            <img
              className={style.rocket__image}
              src="https://fs.advance.ru/landing-pages/images/about_us/advance_rocket/big-rocket.svg"
              alt="Логотип"
            />
          </div>
          <div className={`col-12 col-lg-9`}>
            <h2 className={style.rocket__title}>Мы — Центр образовательных технологий</h2>

            <ul className={`${style.rocket__rowWrapper} row`}>
              <li className={`${style.rocket__colWrapper} col-12 col-lg-4`}>
                <h3 className={style.rocket__subtitle}>С 2009 года</h3>
                <p className="rocket__text">
                  учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность
                </p>
              </li>
              <li className={`${style.rocket__colWrapper} col-12 col-lg-4`}>
                <h3 className={style.rocket__subtitle}>1,7 млн</h3>
                <p className={style.rocket__text}>человек приняли участие в&nbsp;наших курсах и&nbsp;семинарах</p>
              </li>
              <li className={`${style.rocket__colWrapper} col-12 col-lg-4`}>
                <h3 className={style.rocket__subtitle}>85 000</h3>
                <p className={style.rocket__text}>человек прошли наши полные курсы</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
